/* eslint max-len:0 */
'use strict';

class CollectionCaseList {
  constructor($http) {
    this.$http = $http;
  }

  $onInit() {
    this.link = null;
    this.queued = false;
    this.approved = false;
    this.collection = {};
    this.agencyName = '';
    this.agencyHelp = '';
  }

  $onChanges() {
    if (this.link || this.link !== null) {
      this.load();
    }
  }

  load() {
    this.$http.get(this.link)
      .then((resp) => {
        this.collection = resp.data;
        if (this.collection) {
          if (this.collection.collectionAgency === 'BEWA') {
            this.agencyName = 'Collectia AS';
            this.agencyHelp = 'kundesenter@collectiagroup.no';
          } else {
            this.agencyName = 'Intrum';
            this.agencyHelp = 'hjelp@Intrum.com';
          }
        }
      });
  }
}

CollectionCaseList.$inject = ['$http'];

const collectionCaseList = {
  controller: CollectionCaseList,
  bindings: {
    link: '<',
    queued: '<',
    approved: '<'
  },
  template: `
    <ul class="no-bullet">
      <li>
        <b>Inkasso:</b>
        <a ng-if="$ctrl.collection.caseNumber" ng-href="{{ $ctrl.collection._links.case.uri }}" target="_blank" rel="nofollow">{{ $ctrl.collection.caseNumber }}</a>
        <span ng-if="!$ctrl.collection.caseNumber && $ctrl.approved">Du er ikke godkjent som kunde av et inkassobyrå ennå, saken vil bli overført når du blir godkjent</span>
        <span ng-if="!$ctrl.collection.caseNumber && !$ctrl.approved">Saken overføres til inkassobyrået, og behandles av dem i løpet av 1-2 uker</span>
        <span ng-show="$ctrl.agencyName === 'LINDORFF'" data-balloon-length="xlarge" data-balloon-pos="right" data-balloon="Dette er saksnummeret hos inkassobyrået, Intrum. Om du har spørsmål til saken, kan du kontakte dem på {{ $ctrl.agencyHelp }}, og oppgi saksnummeret. Dersom saksnummer ikke er tildelt, er ikke saken akseptert av {{ $ctrl.agencyName }} ennå. Det kan ta opptil to uker fra saken sendes til den aksepteres."><i class="fa fa-question-circle"></i></span>
        <span ng-show="$ctrl.agencyName === 'BEWA'" data-balloon-length="xlarge" data-balloon-pos="right" data-balloon="Dette er saksnummeret hos inkassobyrået, Collectia. Om du har spørsmål til saken, kan du kontakte dem på {{ $ctrl.agencyHelp }}, og oppgi saksnummeret. Dersom saksnummer ikke er tildelt, er ikke saken akseptert av {{ $ctrl.agencyName }} ennå. Det kan ta opptil to uker fra saken sendes til den aksepteres."><i class="fa fa-question-circle"></i></span>
      </li>
    </ul>
  `
};

angular
  .module('SendRegning')
  .component('collectionCaseList', collectionCaseList);
